import React, { useRef, useState } from "react";

import { NavItem, NavLink } from "reactstrap";
import classnames from "classnames/dedupe";

import Icon from "components/icon";
import { createPortal } from "react-dom";

export const OverflowMenu = ({ children, visibilityMap }) => {
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
    const handleToggleMenu = () => setIsMenuOpen((prev) => !prev);

    const buttonRef = useRef<HTMLAnchorElement>(null);

    const buttonBox = buttonRef.current?.getBoundingClientRect();

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

    return (
        <>
            <div style={{ order: Object.entries(visibilityMap).length + 1 }}>
                <NavItem className="tabs-overflow-menu-nav-item">
                    <NavLink
                        innerRef={buttonRef}
                        className={classnames("gt-nav-pills", "rui-tabs-link", "overflow-menu-link", { open: isMenuOpen })}
                        onClick={handleToggleMenu}
                    >
                        <Icon name={"chevron-down"}></Icon>
                    </NavLink>
                    {isMenuOpen &&
                        createPortal(
                            <div
                                className={classnames({ open: isMenuOpen }, "tabs-overflow-menu-container")}
                                style={{
                                    top: buttonBox?.bottom ? buttonBox.bottom + scrollTop : undefined,
                                    right: buttonBox ? window.innerWidth - buttonBox.right + scrollLeft : undefined,
                                }}
                                onClick={handleToggleMenu}
                            >
                                <div className="overflow-menu">{children}</div>
                            </div>,
                            document.body
                        )}
                </NavItem>
            </div>
        </>
    );
};
